import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
// import About from '../views/About.vue'
// import MRS from '../views/mrs/MRS.vue'
// import config from '../config.json'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: () =>
            import ('../views/Home.vue')
            // redirect: { name: 'Home' }
    },
    // {
    //     path: '/home',
    //     name: 'Home',
    //     component: () =>
    //         import ('../views/Home.vue')
    // },
    {
        path: '/logout',
        name: 'Logout',
        component: () =>
            import ('../views/Logout.vue')
            // component : About
    },
    {
        path: '/about-us',
        name: 'About Us',
        component: () =>
            import ('../views/About.vue')
    },
    {
        path: '*',
        redirect: { name: 'Home' }
    },
    {
        path: '/doctorsearch',
        name: 'Doctor Search',
        component: () =>
            import ('../views/eservice/DoctorSearch.vue')
    },
    {
        path: '/dental',
        name: 'Dental List',
        component: () =>
            import ('../views/eservice/DentalList.vue')
    },
    {
        path: '/news',
        name: 'News',
        component: () =>
            import ('../views/eservice/News.vue')
    },
    {
        path: '/newspdf',
        name: 'NewsPDF',
        component: () =>
            import ('../views/eservice/NewsPdf.vue')
    },
    {
        path: '/booklet',
        name: 'BookletQrCode',
        component: () =>
            import ('../views/eservice/Booklet.vue')
    },
    {
        path: '/bookletpdf',
        name: 'Booklet',
        component: () =>
            import ('../views/eservice/BookletPdf.vue')
    },
    {
        path: '/doctormovement',
        name: 'Doctor Movement',
        component: () =>
            import ('../views/eservice/DoctorMovement.vue')
    },
    {
        path: '/comingsoon',
        name: 'Coming Soon',
        component: () =>
            import ('../views/ComingSoon.vue')
    },
    {
        path: '/noneocssservices',
        name: 'NonEocssServices',
        component: () =>
            import ('../views/eservice/NonEocssServices.vue')
    },
    // ,
    // {
    //     path: '/checkup',
    //     name: 'Physical Check-up',
    //     component: () =>
    //         import ('../views/eservice/Checkup.vue')
    // }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router